import { form } from '../../../formState'

import { useTexts } from './hooks/useTexts'

const NOTES_MAX_LENGTH = 1500

export function Notes() {
  const texts = useTexts()

  const { field } = form.useFormField('notes')

  form.useAddFieldValidation('notes', (field, _formApi) => {
    const notes = field.value

    if (notes && notes.status === 'exact') {
      const invalid = notes.value.length > NOTES_MAX_LENGTH

      if (invalid) {
        return texts.invalidNotes(NOTES_MAX_LENGTH)
      }
    }
  })

  const notes = field.value
  const counter =
    notes && notes.status === 'exact' ? `${notes.value.length}/${NOTES_MAX_LENGTH}` : undefined

  return (
    <form.BulkTextField
      name="notes"
      testId="notes"
      mixedLabel={texts.mixed}
      label={texts.notes}
      validateOn="blur"
      debounce={null}
      helperText={counter}
      bulkTextFieldProps={{
        multiline: true,
        rows: 5,
        inputProps: { maxLength: NOTES_MAX_LENGTH },
      }}
    />
  )
}
